module.exports = __webpack_public_path__ + "img/彭祥俊.62b5bdff.jpg";